import { toPublicCorridorSlug } from "@/data/corridors/corridorSeoSlugs";

export const ROUTE_PATHS = {
  /** Marketing home — Duri Ridesharing App India */
  HOME: "/",
  MARKETING_LANDING: "/",
  HOW_DURI_WORKS: "/how-duri-works",
  FIND_RIDES: "/available-rides",
  FIND_RIDE: "/find-ride",
  OFFER_A_RIDE: "/offer-a-ride",
  RIDE_REQUESTS: "/ride-requests",
  DAILY_COMMUTE_CARPOOL: "/daily-commute-carpool",
  CORPORATE_CARPOOL: "/CorporateCarpool",
  POPULAR_ROUTES: "/popular-routes",
  SAFETY: "/safety",
  ABOUT_DURI: "/about-duri",
  NEWS: "/news",
  RIDESHARING_BENEFITS: "/ridesharing-benefits",
  RIDESHARING_IMPACT: "/ridesharing-impact",
  HELP_CENTER: "/help-center",
  FAQS: "/faqs",
  /** Intercity route hub: `/routes/:slug` */
  INTERCITY_ROUTES: "/routes",
  HYDERABAD_DAILY_COMMUTE_CARPOOL: "/hyderabad-daily-commute-carpool",
  HYDERABAD_CARPOOL: "/hyderabad-carpool",
  VIJAYAWADA_RIDESHARING: "/vijayawada-ridesharing",
  BANGALORE_CARPOOL: "/bangalore-carpool",
  CHENNAI_RIDESHARING: "/chennai-ridesharing",
  INTERCITY_RIDESHARING_INDIA: "/intercity-ridesharing-india",
  VIJAYAWADA_DAILY_COMMUTE_CARPOOL: "/vijayawada-daily-commute-carpool",
  GUIDES: "/guides",
  COMMUTE_CALCULATOR: "/commute-calculator",
  EMAIL_VERIFICATION: "/email-verification",
  RIDE_INFO: "/ride-info",
  BOOKING_INFO: "/booking-info",
  TRACK_RIDE: "/track-ride",
  DASHBOARD: "/dashboard",
  DELETE_ACCOUNT: "/delete-account",
  ACCOUNT: "/account",
  TERMS_OF_SERVICES: "/TermsofServices",
  CANCELLATION_POLICY: "/CancellationPolicy",
  TERMS_AND_CONDITIONS: "/TermsAndConditions",
  DATA_PROCESSING_AND_AGREEMENT: "/DataProcessingandAgreement",
  PRIVACY_POLICY: "/privacypolicy",
  DEV_TEAM: "/dev-team",
  VERIFICATION_PROCESS: "/verificationprocess",
  WEBVIEW_INIT: "/webview-init",
} as const;

/** Build public corridor URL from internal registry slug. */
export function corridorPath(internalSlug: string): string {
  return `${ROUTE_PATHS.INTERCITY_ROUTES}/${toPublicCorridorSlug(internalSlug)}`;
}
